var React = require('react');

function DefaultDeviceIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 1a1 1 0 0 1 1 1v2h2V2a1 1 0 1 1 2 0v2h2a3 3 0 0 1 3 3v2h2a1 1 0 1 1 0 2h-2v2h2a1 1 0 1 1 0 2h-2v2a3 3 0 0 1-3 3h-2v2a1 1 0 1 1-2 0v-2h-2v2a1 1 0 1 1-2 0v-2H7a3 3 0 0 1-3-3v-2H2a1 1 0 1 1 0-2h2v-2H2a1 1 0 1 1 0-2h2V7a3 3 0 0 1 3-3h2V2a1 1 0 0 1 1-1zM6 14v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v7z","fill":"#fff"}));
}

DefaultDeviceIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DefaultDeviceIcon;

DefaultDeviceIcon.default = DefaultDeviceIcon;
